var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10C4.7425 10 2.5 7.7575 2.5 5C2.5 2.2425 4.7425 0 7.5 0C10.2575 0 12.5 2.2425 12.5 5C12.5 7.7575 10.2575 10 7.5 10ZM18.9133 15.945L18.1017 15.4767C18.24 15.0625 18.3333 14.6275 18.3333 14.1667C18.3333 13.7058 18.2408 13.2708 18.1017 12.8567L18.9133 12.3883C19.3117 12.1583 19.4483 11.6483 19.2183 11.25C18.9875 10.8508 18.4792 10.7133 18.08 10.945L17.2692 11.4133C16.6817 10.7517 15.8992 10.2675 15 10.085V9.1675C15 8.7075 14.6267 8.33417 14.1667 8.33417C13.7067 8.33417 13.3333 8.7075 13.3333 9.1675V10.085C12.4342 10.2683 11.6517 10.7525 11.0642 11.4133L10.2533 10.945C9.85333 10.7142 9.345 10.8508 9.115 11.25C8.885 11.6492 9.02167 12.1583 9.42 12.3883L10.2317 12.8567C10.0933 13.2708 10 13.7058 10 14.1667C10 14.6275 10.0925 15.0625 10.2317 15.4767L9.42 15.945C9.02167 16.175 8.885 16.685 9.115 17.0833C9.27 17.3508 9.54917 17.5 9.8375 17.5C9.97833 17.5 10.1217 17.4642 10.2533 17.3883L11.0642 16.92C11.6517 17.5817 12.4342 18.0658 13.3333 18.2483V19.1658C13.3333 19.6258 13.7067 19.9992 14.1667 19.9992C14.6267 19.9992 15 19.6258 15 19.1658V18.2483C15.8992 18.065 16.6817 17.5808 17.2692 16.92L18.08 17.3883C18.2117 17.4642 18.355 17.5 18.4958 17.5C18.7842 17.5 19.0642 17.3508 19.2183 17.0833C19.4483 16.6842 19.3117 16.175 18.9133 15.945ZM14.1667 15.4167C13.4775 15.4167 12.9167 14.8558 12.9167 14.1667C12.9167 13.4775 13.4775 12.9167 14.1667 12.9167C14.8558 12.9167 15.4167 13.4775 15.4167 14.1667C15.4167 14.8558 14.8558 15.4167 14.1667 15.4167ZM6.66667 14.1667C6.66667 13.2967 6.8225 12.4642 7.095 11.6875C3.14833 11.8992 0 15.1683 0 19.1667C0 19.6267 0.373333 20 0.833333 20H9.4575C7.75667 18.625 6.66667 16.5242 6.66667 14.1667Z",
    fill: "url(#paint0_linear_381_38)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_38",
    x1: 9.66501,
    y1: 0,
    x2: 9.66501,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.4bb2c97b9ad10c8f8ad44e1b41ed363a.svg";
export { ForwardRef as ReactComponent };